import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import FiliaisOuvidoriaCard from './components/FiliaisOuvidoriaCard';

const FiliaisOuvidoriaMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[{ name: 'Inicio' }, { name: 'Filiais da Ouvidoria' }]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <FiliaisOuvidoriaCard />
      </Col>
    </Row>
  </Container>
);

export default FiliaisOuvidoriaMain;
